import React, { PropTypes } from 'react';
import Portal from 'react-portal';

import ButtonLink from '../ButtonLink';
import Close from '../Close';

import { close, modal, iframe, overlay } from './styles.module.css';

const VideoPortalModal = ({ closePortal, src }) => (
  <div>
    <div className={['modal', 'modal--form', modal].join(' ')} onClick={closePortal}>
      <Close white className={close} />
      <iframe
        width="100%"
        height="100%"
        frameBorder="0"
        allowFullScreen
        className={iframe}
        src={src}
      />
    </div>
    <div className={overlay} onClick={closePortal} />
  </div>
);


VideoPortalModal.propTypes = {
  /**
   * Closes portal on click.
   */
  closePortal: PropTypes.func,
  /**
   * String source for video iframe.
   */
  src: PropTypes.string.isRequired,
};

VideoPortalModal.defaultProps = {
  closePortal: undefined,
};


const VideoPortal = ({ className, text, ...props }) => {
  const modalLauncher = <ButtonLink className={className}>{text}</ButtonLink>;
  return (
    <Portal closeOnEsc openByClickOn={modalLauncher}>
      <VideoPortalModal {...props} />
    </Portal>
  );
};

VideoPortal.propTypes = {
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * Text to render inside button.
   */
  text: PropTypes.string,

};

VideoPortal.defaultProps = {
  className: '',
  text: 'Play Video',
};

export default VideoPortal;



// WEBPACK FOOTER //
// ./app/src/components/VideoPortal/index.jsx